export const ADD_SELECTIONS = "ADD_SELECTIONS";
